<template>
  <base-container
    class="layout-row"
    style="align-items: start"
    ref="container"
    :isLoading="loading"
  >
    <artisan-group
      style="height: 100%; width: 20%; border: none; overflow-y: auto"
      title="检查资源"
    >
      <el-tree
        :data="treeData"
        node-key="key"
        default-expand-all
        ref="tree"
        highlight-current
        :props="{ label: 'name' }"
        :expand-on-click-node="false"
        @current-change="treeChange"
      >
        <el-row
          style="flex: 1"
          type="flex"
          align="middle"
          slot-scope="{ node, data }"
        >
          <span :class="'color-' + getTypeTag(data.belongType)">
            {{ node.label }}
          </span>
          <span
            style="font-size: 0.7rem; margin: 0 5px"
            :class="data.hasConfig ? 'color-success' : 'color-danger'"
          >
            ({{ data.hasConfig ? "已设置" : "未设置" }})
          </span>
        </el-row>
      </el-tree>
    </artisan-group>
    <artisan-group :title="configTitle" style="flex: 1; margin: 10px">
      <el-form
        v-if="config.key"
        style="background-color: white; padding: 10px"
        :model="configForm"
        ref="configForm"
        label-width="100px"
      >
        <el-form-item
          v-if="config.belongType !== 'room'"
          label="申请单同步"
          prop="syncAbleType"
        >
          <el-checkbox
            v-model="configForm.syncAbleType"
            true-label="on"
            false-label="off"
          >
            申请单同步
          </el-checkbox>
          <span class="margin-h3">-</span>
          <el-select
            size="mini"
            v-model="configForm.syncClinicType"
            placeholder="就诊类型"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="门诊" value="outpatient"></el-option>
            <el-option label="住院" value="inpatient"></el-option>
          </el-select>
          <span class="margin-h5 color-warning">
            <b>(</b>
            配置是否同步对应资源【院区、科室】下的【门诊、住院或全部】的检查申请单
            <b>)</b>
          </span>
        </el-form-item>
        <el-form-item
          v-if="config.belongType !== 'room'"
          label="自动预约"
          prop="resAbleType"
        >
          <el-checkbox
            v-model="configForm.resAbleType"
            true-label="on"
            false-label="off"
          >
            自动预约
          </el-checkbox>
          <span class="margin-h3">-</span>
          <el-select
            style="width: 210px"
            size="mini"
            v-model="configForm.resClinicType"
            placeholder="就诊类型"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="门诊" value="outpatient"></el-option>
            <el-option label="住院" value="inpatient"></el-option>
          </el-select>
          <span class="margin-h5 color-warning">
            <b>(</b>
            配置【院区、科室】下的【门诊、住院或全部】的检查申请单是否开启自动预约
            <b>)</b>
          </span>
        </el-form-item>
        <el-form-item label="开启消息" prop="msgAbleType">
          <el-checkbox
            v-model="configForm.msgAbleType"
            true-label="on"
            false-label="off"
          >
            开启消息
          </el-checkbox>
          <span class="margin-h3">-</span>
          <el-select
            style="width: 210px"
            size="mini"
            v-model="configForm.msgClinicType"
            placeholder="就诊类型"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="门诊" value="outpatient"></el-option>
            <el-option label="住院" value="inpatient"></el-option>
          </el-select>
          <span class="margin-h5 color-warning">
            <b>(</b>
            配置【院区、科室】下的【门诊、住院或全部】的检查申请单是否开启消息发送
            <b>)</b>
          </span>
        </el-form-item>
        <el-form-item label="预约开始日期" prop="resStartDate">
          <el-date-picker
            style="width: 300px"
            size="mini"
            v-model="configForm.resStartDate"
            :pickerOptions="pickerOptions"
            type="date"
            placeholder="预约开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          <span class="margin-h5 color-warning">
            <b>(</b>
            配置患者在预约相应的检查资源时，只可以预约【预约开始日期】后的班次
            <b>)</b>
          </span>
        </el-form-item>
        <el-form-item label="最大预约天数" prop="resDayCount">
          <el-input-number
            style="width: 300px"
            size="mini"
            v-model="configForm.resDayCount"
            controls-position="right"
            :min="1"
            :max="300"
          ></el-input-number>
          <span class="margin-h5 color-warning">
            <b>(</b>
            配置患者在预约相应的检查资源时，可以预约当前日期至【最大预约天数】日期内的班次
            <b>)</b>
          </span>
        </el-form-item>
        <el-form-item label="最大排班天数" prop="scheduleDayCount">
          <el-input-number
            style="width: 300px"
            size="mini"
            v-model="configForm.scheduleDayCount"
            controls-position="right"
            :min="1"
            :max="300"
          ></el-input-number>
          <span class="margin-h5 color-warning">
            <b>(</b>
            配置检查资源自动生成【最大排班天数】的班次
            <b>)</b>
          </span>
        </el-form-item>
        <el-form-item label="打印模板" prop="printId">
          <el-select
            style="width: 300px"
            size="mini"
            v-model="configForm.printId"
            placeholder="打印模板"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="item in printList"
              :key="item.id"
            ></el-option>
          </el-select>
          <span class="margin-h5 color-warning">
            <b>(</b>
            配置患者在预约签到时需要打印凭条的【打印模板】
            <b>)</b>
          </span>
        </el-form-item>
        <div style="width: 400px; text-align: center">
          <div
            v-if="inheritDesc"
            class="color-danger text-bold text-large margin-v10"
          >
            {{ inheritDesc }}
          </div>
          <el-button
            v-if="config.key"
            type="success"
            size="mini"
            icon="el-icon-check"
            @click="saveConfig()"
          >
            保存
          </el-button>
        </div>
      </el-form>
      <el-empty v-else description="请先选择左侧要配置的资源"></el-empty>
    </artisan-group>
  </base-container>
</template>

<script>
import {
  getResourcesConfig,
  saveOrUpdate,
  list,
} from "@/api/jc/resource-config";
import { buildTree } from "@/util/util";
export default {
  data() {
    return {
      loading: false,
      resList: [],
      inheritDesc: "",
      config: {},
      configForm: {},
      defaultProps: {
        children: "children",
        label: "name",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      printList: [],
    };
  },
  computed: {
    treeData() {
      let tree = buildTree(this.resList, {
        idField: "key",
        parentField: "parentKey",
      });
      return tree;
    },
    configTitle() {
      let title = `资源配置【${this.getTypeLabel(this.config.belongType)}】${
        this.config.name || ""
      }`;
      return title;
    },
  },
  created() {
    list().then((res) => {
      this.printList = res.data.data;
    });
    this.loadData();
  },
  methods: {
    treeChange(data) {
      this.config = data;
      let content = {};
      if (data.hasConfig) {
        content = Object.assign(content, data.content);
        this.inheritDesc = "";
      } else {
        let upConfig = this.resList.find((c) => c.key == data.parentKey);
        if (upConfig && upConfig.hasConfig) {
          content = Object.assign(content, upConfig.content);
          this.inheritDesc = `继承${this.getTypeLabel(upConfig.belongType)}【${
            upConfig.name
          }】的部分配置`;
        } else {
          upConfig = this.resList.find((c) => c.key == upConfig.parentKey);
          if (upConfig && upConfig.hasConfig) {
            content = Object.assign(content, upConfig.content);
            this.inheritDesc = `继承${this.getTypeLabel(
              upConfig.belongType
            )}【${upConfig.name}】的部分配置`;
          } else {
            this.inheritDesc = "";
          }
        }
      }
      this.configForm = content;
    },
    loadData() {
      this.loading = true;
      getResourcesConfig()
        .then((res) => {
          let data = res.data.data;
          data.forEach((c) => {
            c.content = c.content || {};
          });
          this.resList = data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getClinicTypeLabel(type) {
      let label = "";
      switch (type) {
        case "":
          label = "全部";
          break;
        case "outpatient":
          label = "门诊";
          break;
        case "inpatient":
          label = "住院";
          break;
      }
      return label;
    },
    getTypeLabel(type) {
      let label = "";
      switch (type) {
        case "hos":
          label = "院区";
          break;
        case "dept":
          label = "科室";
          break;
        case "room":
          label = "检查室";
          break;
      }
      return label;
    },
    getTypeTag(type) {
      let tag = "primary";
      switch (type) {
        case "hos":
          tag = "primary";
          break;
        case "dept":
          tag = "success";
          break;
        case "room":
          tag = "warning";
          break;
      }
      return tag;
    },
    saveConfig() {
      this.$refs.container
        .confirm({
          msg: "确认保存资源配置?",
        })
        .then(() => {
          this.loading = true;
          this.config.content = this.configForm;
          return saveOrUpdate(this.config);
        })
        .then(() => {
          this.$message({
            message: "保存成功！",
            type: "success",
          });
          this.loading = false;
          this.config.hasConfig = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
